import React from "react";
import { tSafe } from "../_helpers/language";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

// Подтверждение действия вместо window.confirm: системный диалог WebView рисует
// над вопросом служебную строку «Веб-страница по адресу http://localhost сообщает»,
// убрать которую нельзя — она часть диалога Android и берётся из origin страницы.
// Заголовка у нашего диалога нет вообще: вопрос и есть заголовок.
//
// Состояния компонент не держит: в кабинете им управляет SnackbarProvider
// (там же один диалог на всё приложение, как и снэк), в режиме «визитка» — CardShell.
export function ConfirmDialog({
  open,
  text,
  confirmLabel,
  onConfirm,
  onCancel,
  paperClass = "confirm-dialog",
  textClass = "confirm-dialog__text",
}) {
  return (
    <Dialog open={open} onClose={onCancel} PaperProps={{ className: paperClass }}>
      <DialogContent className={textClass}>{text}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{tSafe("btn_cancel")}</Button>
        <Button onClick={onConfirm}>{confirmLabel || tSafe("btn_ok")}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
